module.exports = __webpack_public_path__ + "static/media/vitech.fad874ee.jpg";